import { type RouteParams, RouteParamsSchema } from '../schemas.ts'

export const isRouteParams = (params: unknown): params is RouteParams => {
  return RouteParamsSchema.safeParse(params).success
}

export const getRouteParam = <Key extends keyof RouteParams>(
  params: unknown,
  key: Key
): RouteParams[Key] | undefined => {
  return isRouteParams(params) ? params[key] : undefined
}
